export default "__VITE_ASSET__5079590a__"